import { JWTPayload } from 'jose';

export const tokenKey = 'qlf_token';
export const audience = 'participant-frontend';

export interface QlfAuthTokenPayload extends JWTPayload {
  accountId: string;
  profileId: string;
  internalUser?: boolean;
  data?: Record<string, unknown>;
}
